// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post, del } from "./api_client";
import { DeviceKey, IDeviceKey, AllocatedDeviceKeyResult, IAllocatedDeviceKeyResult, DeviceKeySearchResult, IDeviceKeySearchResult } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getPending(includePrinted: boolean): ApiResult<DeviceKey[]> {
		const queryParams = [includePrinted !== undefined ? `includePrinted=${includePrinted}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IDeviceKey[]>(`/api/devicekey/pending${query}`).then(result => result === undefined ? undefined : result.map(o => new DeviceKey(o)));
}

export async function generate(count: number): ApiResult<number> {
		const queryParams = [count !== undefined ? `count=${count}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return post<number>(`/api/devicekey/generate${query}`);
}

export async function deleteKey(id?: string): ApiResult<undefined> {
	return del(`/api/devicekey/${ id }`);
}

export async function markPrinted(ids?: string[]): ApiResult<number> {
	return post<number>(`/api/devicekey/mark-printed`, ids);
}

export async function getRecentlyAllocated(limit: number): ApiResult<AllocatedDeviceKeyResult[]> {
		const queryParams = [limit !== undefined ? `limit=${limit}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IAllocatedDeviceKeyResult[]>(`/api/devicekey/recently-allocated${query}`).then(result => result === undefined ? undefined : result.map(o => new AllocatedDeviceKeyResult(o)));
}

export async function search(q?: string): ApiResult<DeviceKeySearchResult> {
		const queryParams = [q !== undefined ? `q=${q}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IDeviceKeySearchResult>(`/api/devicekey/search${query}`).then(result => result === undefined ? undefined :  new DeviceKeySearchResult(result));
}
